module.exports = __webpack_public_path__ + "img/2.2cb40b42.png";